import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { createSelector } from 'reselect'

import { collectSobDataDependsOnSettings } from 'partner360/features/competitorsSob/helpers/collectSobDataDependsOnSettings'

import { selectQbrState } from './selectQbrState'

export const selectQbrPCSobCompetitorsDependOnSettings = createSelector(
  [selectQbrState],
  ({ selectedDocument, documentSettings }) => {
    if (!selectedDocument) {
      return []
    }

    const sobCompetitors = selectedDocument.SobCompetitors[ProgramTypes.PC] || []
    const netNdp = documentSettings.netNdp
    const currency = documentSettings.currency
    const rounding = documentSettings.rounding
    return collectSobDataDependsOnSettings({ sobCompetitors, netNdp, currency, rounding })
  }
)
